export const addClassListToSVG = () => {
    if (!('classList' in SVGElement.prototype)) {
        Object.defineProperty(SVGElement.prototype, 'classList', {
            get() {
                return {
                    contains: (className: string) => {
                        return this.className.baseVal.split(' ').indexOf(className) !== -1;
                    }
                };
            }
        });
    }
}